import * as types from './types';

const dutyPlannerDataReceived = (startTime, endTime, groupId, defaultFunctionId) => ({
  type: types.DUTY_PLANNER_DATA_RECEIVED,
  payload: {
    startTime,
    endTime,
    groupId,
    defaultFunctionId
  }
});

export { dutyPlannerDataReceived };
